import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children, requireAdmin = false }) => {
  const { currentUser, loading } = useAuth();
  const location = useLocation();

  // Show loading while checking auth
  if (loading) {
    return (
      <div className="loading-screen">
        <div className="loading-content">
          <div className="spinner"></div>
          <h3>Loading...</h3>
          <p>Checking authentication</p>
        </div>
      </div>
    );
  }

  // If no user is logged in, redirect to login
  if (!currentUser) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  // If admin is required but user is not admin, redirect to home
  if (requireAdmin && !(currentUser.role === 'admin' || currentUser.isAdmin === true)) {
    return <Navigate to="/" state={{ message: 'Access denied. Admin privileges required.' }} replace />;
  }

  // User is authenticated (and admin if required)
  return children;
};

export default ProtectedRoute;